export const personnelQuestions = {
  conversation1: {
    id: 1,
    title: "Quality Control & Defective Products",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p1.mp3",
        script: `W: James, I just got the results from the quality inspection on the latest batch of <mark>circuit boards</mark>. <mark>15% of them failed the test</mark>.
<span class="translation">(James, 방금 최근 회로 기판 배치에 대한 품질 검사 결과를 받았어요. 15%가 테스트에 불합격했어요.)</span>

M: That's concerning. What's the issue?
<span class="translation">(걱정되네요. 무슨 문제인가요?)</span>

W: The soldering isn't uniform, which could cause <mark>connection failures</mark>. Should we return the defective units to the supplier, or can they be reworked?
<span class="translation">(납땜이 균일하지 않아서 연결 오류가 발생할 수 있어요. 불량품을 공급업체에 반품해야 할까요, 아니면 재작업이 가능할까요?)</span>

M: The production team thinks reworking them will take three extra days.
<span class="translation">(생산팀은 재작업하는 데 3일이 더 걸릴 것 같다고 해요.)</span>

W: That might still be faster than ordering new ones. <mark>Can we inform the client about the situation</mark>?
<span class="translation">(그래도 새로 주문하는 것보다는 빠를 것 같네요. 고객에게 상황을 알려도 될까요?)</span>

M: Yes, <mark>I'll send them a status</mark> update this afternoon.
<span class="translation">(네, 오후에 상황 업데이트를 보내드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem was discovered?",
        options: {
          A: "A <mark>shipment</mark> was lost",
          B: "The <mark>circuit boards</mark> failed the quality test",
          C: "The supplier sent the <mark>wrong</mark> <mark>materials</mark>",
          D: "The <mark>production schedule</mark> was delayed",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The circuit boards failed the quality test

대본 키워드: "15% of them failed the test."
보기 키워드: "The circuit boards failed the quality test"

❌ 오답 트랩:
(A) A shipment was lost 
→ 배송 문제 언급 없음

(C) The supplier sent the wrong materials 
→ 자재 문제 언급 없음

(D) The production schedule was delayed 
→ 품질 문제이지 일정 지연 문제 아님`,
      },
      {
        id: 2,
        question:
          "What issue does <mark>the woman</mark> say could result from the defect?",
        options: {
          A: "<mark>Connection</mark> failures",
          B: "<mark>Power</mark> <mark>surges</mark>",
          C: "<mark>Overheating</mark> of components",
          D: "<mark>Software</mark> <mark>incompatibility</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Connection failures
      
      대본 키워드: "The soldering isn't uniform, which could cause connection failures."
      보기 키워드: "Connection failures"
      
      ❌ 오답 트랩:
      (B) Power surges 
      → 전력 서지 언급 없음
      
      (C) Overheating of components 
      → 과열 문제 언급 없음
      
      (D) Software incompatibility 
      → 소프트웨어 호환성 문제 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "<mark>Request</mark> a <mark>refund</mark> from the <mark>supplier</mark>",
          B: "<mark>Inform the client</mark> about the situation",
          C: "<mark>Approve</mark> a production <mark>shutdown</mark>",
          D: "Order <mark>new</mark> <mark>materials</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Inform the client about the situation

대본 키워드: "Yes, I'll send them a status update this afternoon."
보기 키워드: "Inform the client about the situation"

❌ 오답 트랩:
(A) Request a refund from the supplier 
→ 환불 요청 언급 없음

(C) Approve a production shutdown 
→ 생산 중단 승인 언급 없음

(D) Order new materials 
→ 새 자재 주문 언급 없음`,
      },
    ],
  },
  conversation2: {
    id: 2,
    title: "Increasing Production Output",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p2.mp3",
        script: `<mark>M</mark>: Hi, Sarah. We just got a major order from Global Auto Parts. They need <mark>2,000 units</mark> instead of 1,200, and they want it within two weeks.
<span class="translation">(안녕하세요, Sarah. 방금 Global Auto Parts로부터 대규모 주문을 받았어요. 1,200개가 아닌 2,000개가 필요하다고 하네요, 2주 안에요.)</span>

<mark>W</mark>: That's a big jump. Can we meet that deadline with our current production rate?
<span class="translation">(큰 증가네요. 현재 생산율로 그 마감일을 맞출 수 있을까요?)</span>

<mark>M</mark>: It'll be difficult, but I spoke with the plant supervisor. If we extend shifts by <mark>two hours</mark> each day, we should be able to meet the demand.
<span class="translation">(어렵겠지만, 공장 감독관과 얘기해봤어요. 매일 근무 시간을 2시간씩 연장하면 수요를 맞출 수 있을 것 같아요.)</span>

<mark>W</mark>: That could work. Will we need more raw materials?
<span class="translation">(그렇게 하면 원자재가 더 필요할까요?)</span>

<mark>M</mark>: I checked with our supplier. They can provide the extra materials by next Monday, but we need to <mark>confirm</mark> by <mark>this afternoon</mark>.
<span class="translation">(공급업체에 확인해봤어요. 다음 주 월요일까지 추가 자재를 제공할 수 있지만, 오늘 오후까지 확정해야 한대요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question:
          "What is the main issue <mark>the speakers</mark> are discussing?",
        options: {
          A: "A <mark>sudden increase</mark> in production demand",
          B: "A <mark>technical</mark> issue with the production <mark>line</mark>",
          C: "A <mark>delay</mark> in material <mark>delivery</mark>",
          D: "A machine <mark>breakdown</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A sudden increase in production demand

대본 키워드: "They need 2,000 units instead of 1,200, and they want it within two weeks."
보기 키워드: "A sudden increase in production demand"

❌ 오답 트랩:
(B) A technical issue with the production line 
→ 기술적 문제 언급 없음

(C) A delay in material delivery 
→ 자재 공급 지연이 아니라 생산량 증가 문제

(D) A machine breakdown 
→ 기계 고장 언급 없음`,
      },
      {
        id: 2,
        question: "What solution does <mark>the man</mark> suggest?",
        options: {
          A: "Hiring more <mark>workers</mark>",
          B: "Extending shifts by <mark>two hours</mark>",
          C: "Cancelling other <mark>orders</mark>",
          D: "Increasing machine <mark>speed</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Extending shifts by two hours

대본 키워드: "If we extend shifts by two hours each day, we should be able to meet the demand."
보기 키워드: "Extending shifts by two hours"

❌ 오답 트랩:
(A) Hiring more workers 
→ 추가 인력 고용 언급 없음

(C) Cancelling other orders 
→ 기존 주문을 취소한다는 내용 없음

(D) Increasing machine speed 
→ 기계 속도 조절 관련 언급 없음`,
      },
      {
        id: 3,
        question: "What must the company do by <mark>this afternoon</mark>?",
        options: {
          A: "Confirm the <mark>additional</mark> <mark>material</mark> order",
          B: "Schedule <mark>maintenance</mark> for production machines",
          C: "<mark>Notify</mark> the client of a <mark>delay</mark>",
          D: "<mark>Train</mark> employees on new procedures",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Confirm the additional material order

대본 키워드: "They can provide the extra materials by next Monday, but we need to confirm by this afternoon."
보기 키워드: "Confirm the additional material order"

❌ 오답 트랩:
(B) Schedule maintenance for production machines 
→ 기계 유지보수 관련 언급 없음

(C) Notify the client of a delay 
→ 배송 지연이 아니라 생산량 증가 문제

(D) Train employees on new procedures 
→ 직원 교육 관련 내용 없음`,
      },
    ],
  },
  conversation3: {
    id: 3,
    title: "Safety Training",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p3.mp3",
        script: `<mark>M</mark>: Hi, Lisa. I saw a notice about <mark>mandatory safety training</mark> next Monday. Do all employees have to attend?
<span class="translation">(안녕하세요, Lisa. 다음 주 월요일 필수 안전 교육에 대한 공지를 봤어요. 모든 직원이 참석해야 하나요?)</span>

<mark>W</mark>: Yes, all factory workers must complete this training <mark>once a year</mark>. It covers emergency procedures and workplace hazard prevention.
<span class="translation">(네, 모든 공장 직원들은 이 교육을 연 1회 이수해야 해요. 비상 절차와 작업장 위험 예방에 대한 내용을 다룹니다.)</span>

<mark>M</mark>: Got it. Do we need to sign up, or is everyone automatically enrolled?
<span class="translation">(알겠습니다. 등록해야 하나요, 아니면 자동으로 등록되나요?)</span>

<mark>W</mark>: The HR department has already registered everyone. Just make sure to be at the training room by <mark>9 AM</mark>.
<span class="translation">(HR 부서에서 이미 모든 직원을 등록했어요. 오전 9시까지 교육장에 도착하시기만 하면 됩니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "A new hiring <mark>policy</mark>",
          B: "A mandatory <mark>safety</mark> <mark>training</mark> <mark>session</mark>",
          C: "An employee <mark>performance</mark> <mark>review</mark>",
          D: "A change in <mark>company</mark> <mark>benefits</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A mandatory safety training session

대본 키워드: "I saw a notice about mandatory safety training next Monday."
보기 키워드: "A mandatory safety training session"

❌ 오답 트랩:
(A) A new hiring policy 
→ 채용 정책이 아니라 안전 교육

(C) An employee performance review 
→ 직원 성과 평가 언급 없음

(D) A change in company benefits 
→ 복지 혜택이 아니라 안전 교육`,
      },
      {
        id: 2,
        question: "What does <mark>the man</mark> say about the training?",
        options: {
          A: "It is required <mark>annually</mark>",
          B: "It is <mark>optional</mark> for employees",
          C: "It will be held <mark>online</mark>",
          D: "It is only for <mark>new</mark> <mark>hires</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) It is required annually

대본 키워드: "All factory workers must complete this training once a year."
보기 키워드: "It is required annually"

❌ 오답 트랩:
(B) It is optional for employees 
→ 선택이 아닌 필수 교육

(C) It will be held online 
→ 온라인이 아닌 오프라인 교육

(D) It is only for new hires 
→ 신입 직원만이 아닌 전체 직원 대상`,
      },
      {
        id: 3,
        question: "What must the employees do to attend the training?",
        options: {
          A: "Arrive at the training room by <mark>9 AM</mark>",
          B: "Register <mark>online</mark> in <mark>advance</mark>",
          C: "Submit a <mark>safety</mark> <mark>report</mark> <mark>beforehand</mark>",
          D: "Bring their own <mark>safety</mark> <mark>gear</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Arrive at the training room by 9 AM

대본 키워드: "Just make sure to be at the training room by 9 AM."
보기 키워드: "Arrive at the training room by 9 AM"

❌ 오답 트랩:
(B) Register online in advance 
→ 온라인 등록이 아닌 HR 부서에서 자동 등록

(C) Submit a safety report beforehand 
→ 안전 보고서 제출 언급 없음

(D) Bring their own safety gear 
→ 안전 장비 지참 언급 없음`,
      },
    ],
  },
  conversation4: {
    id: 4,
    title: "Weather Issues",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p4.mp3",
        script: `<mark>W</mark>: Hi, Kevin. The weather forecast says there's a <mark>storm</mark> coming tomorrow. Will that affect our deliveries?
<span class="translation">(안녕하세요, Kevin. 일기예보에 따르면 내일 폭풍이 온대요. 배송에 영향이 있을까요?)</span>

<mark>M</mark>: Yes, it will. The highway to Denver is expected to be closed due to heavy snowfall.
<span class="translation">(네, 있을 거예요. 폭설로 인해 덴버로 가는 고속도로가 폐쇄될 예정이에요.)</span>

<mark>W</mark>: That's a problem. Can we push back the deliveries, or is there another option?
<span class="translation">(문제네요. 배송을 연기할 수 있을까요, 아니면 다른 방법이 있나요?)</span>

<mark>M</mark>: The best option is to send the shipments by <mark>train</mark> instead of trucks. That way, they can still arrive on time.
<span class="translation">(가장 좋은 방법은 트럭 대신 기차로 화물을 보내는 거예요. 그러면 여전히 제시간에 도착할 수 있어요.)</span>

<mark>W</mark>: That sounds like a good solution. Let's <mark>check with the shipping company</mark> and confirm availability.
<span class="translation">(좋은 해결책 같네요. 운송회사에 확인하고 이용 가능 여부를 확인해보죠.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What potential problem is being discussed?",
        options: {
          A: "<mark>Road</mark> <mark>construction</mark>",
          B: "An upcoming <mark>storm</mark>",
          C: "A <mark>mechanical</mark> failure",
          D: "A <mark>fuel supply</mark> issue",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) An upcoming storm
      
      대본 키워드: "The weather forecast says there's a storm coming tomorrow."
      보기 키워드: "An upcoming storm"
      
      ❌ 오답 트랩:
      (A) Road construction 
      → 공사 언급 없음
      
      (C) A mechanical failure 
      → 차량 고장 관련 내용 없음
      
      (D) A fuel supply issue 
      → 연료 문제 언급 없음`,
      },
      {
        id: 2,
        question: "What alternative solution is suggested?",
        options: {
          A: "Using a <mark>train</mark> for <mark>delivery</mark>",
          B: "Delaying the shipment by a <mark>week</mark>",
          C: "<mark>Canceling</mark> all outgoing orders",
          D: "Shipping items by <mark>air</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Using a train for delivery

대본 키워드: "The best option is to send the shipments by train instead of trucks."
보기 키워드: "Using a train for delivery"

❌ 오답 트랩:
(B) Delaying the shipment by a week 
→ 일주일 연기 언급 없음

(C) Canceling all outgoing orders 
→ 주문 취소 언급 없음

(D) Shipping items by air 
→ 항공 운송 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Check with the <mark>shipping company</mark> for availability",
          B: "Move the shipments to a <mark>different</mark> <mark>warehouse</mark>",
          C: "<mark>Contact customers</mark> about the delay",
          D: "Order additional <mark>supplies</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Check with the shipping company for availability

대본 키워드: "Let me check with the shipping company and confirm availability."
보기 키워드: "Check with the shipping company for availability"

❌ 오답 트랩:
(B) Move the shipments to a different warehouse 
→ 창고 이동 언급 없음

(C) Contact customers about the delay 
→ 고객 연락 언급 없음

(D) Order additional supplies 
→ 추가 물품 주문 언급 없음`,
      },
    ],
  },

  conversation5: {
    id: 5,
    title: "Checking Compliance Violations",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p5.mp3",
        script: `<mark>M</mark>: Hi, Claire. I just <mark>completed the monthly safety inspection, and I found a few compliance issues</mark>.
<span class="translation">(안녕하세요, Claire. 방금 월간 안전 점검을 완료했는데, 몇 가지 규정 위반 사항을 발견했어요.)</span>

<mark>W</mark>: Oh? What kind of violations?
<span class="translation">(오? 어떤 위반 사항인가요?)</span>

<mark>M</mark>: Some workers in the warehouse weren't wearing <mark>protective gloves</mark>, even though it's required when handling chemicals.
<span class="translation">(창고의 일부 직원들이 화학물질을 다룰 때 필수인 보호 장갑을 착용하지 않았어요.)</span>

<mark>W</mark>: That's a serious violation. Should we issue a warning?
<span class="translation">(심각한 위반이네요. 경고를 발행해야 할까요?)</span>

<mark>M</mark>: Yes. I'll <mark>write a report</mark> and <mark>send a reminder</mark> to all employees about the safety rules.
<span class="translation">(네. 보고서를 작성하고 모든 직원들에게 안전 규칙에 대한 리마인더를 보내겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What was discovered during the inspection?",
        options: {
          A: "Several <mark>machines</mark> were not <mark>functioning</mark> properly",
          B: "The <mark>fire exit</mark> was <mark>blocked</mark>",
          C: "Some employees were not following <mark>safety</mark> <mark>guidelines</mark>",
          D: "There was a <mark>chemical</mark> <mark>spill</mark> in the warehouse",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Some employees were not following safety guidelines


❌ 오답 트랩:
(A) Several machines were not functioning properly 
→ 기계 고장 관련 언급 없음

(B) The fire exit was blocked 
→ 비상구 관련 문제 언급 없음

(D) There was a chemical spill in the warehouse 
→ 화학물질 유출 언급 없음`,
      },
      {
        id: 2,
        question: "What safety rule was violated?",
        options: {
          A: "Workers failed to <mark>report</mark> an <mark>accident</mark>",
          B: "Employees failed to wear protective <mark>gloves</mark>",
          C: "Employees left <mark>dangerous equipment</mark> unattended",
          D: "Workers did not attend the <mark>safety</mark> <mark>training</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Employees failed to wear protective gloves

대본 키워드: "Some workers in the warehouse weren't wearing protective gloves."
보기 키워드: "Employees failed to wear protective gloves"

❌ 오답 트랩:
(A) Workers failed to report an accident 
→ 사고 보고 누락 언급 없음

(C) Employees left dangerous equipment unattended 
→ 장비 방치 관련 언급 없음

(D) Workers did not attend the safety training 
→ 교육 미이수 관련 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "<mark>Suspend</mark> the workers involved",
          B: "Write a <mark>report</mark> and send a <mark>reminder</mark>",
          C: "Conduct a full <mark>factory</mark> <mark>shutdown</mark>",
          D: "Order <mark>new</mark> <mark>safety</mark> <mark>equipment</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Write a report and send a reminder

대본 키워드: "I'll write a report and send a reminder to all employees about the safety rules."
보기 키워드: "Write a report and send a reminder"

❌ 오답 트랩:
(A) Suspend the workers involved 
→ 징계 조치 관련 언급 없음

(C) Conduct a full factory shutdown 
→ 공장 가동 중단 관련 내용 없음

(D) Order new safety equipment 
→ 새로운 장비 주문 언급 없음`,
      },
    ],
  },
  conversation6: {
    id: 6,
    title: "Contacting a Supplier",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p6.mp3",
        script: `M: Hi, Rachel. Have you <mark>received a response from our supplier</mark> about the next shipment of steel components?
<span class="translation">(안녕하세요, Rachel. 다음 철강 부품 배송에 대해 공급업체로부터 답변을 받으셨나요?)</span>

W: Yes, but there's a slight delay. Instead of arriving on Wednesday, it's been pushed to Friday.
<span class="translation">(네, 하지만 약간의 지연이 있어요. 수요일이 아닌 금요일에 도착할 예정이에요.)</span>

M: That's going to affect our production schedule. <mark>Can they expedite the delivery?</mark>
<span class="translation">(그러면 우리 생산 일정에 영향을 미치겠네요. 배송을 앞당길 수 있나요?)</span>

W: I asked, but they said it's not possible. <mark>However, they can send a partial shipment tomorrow.</mark>
<span class="translation">(문의해봤지만, 불가능하다고 하네요. 하지만 내일 일부 물량을 보낼 수는 있대요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the man</mark> asking about?",
        options: {
          A: "A supplier's <mark>response</mark> about a <mark>shipment</mark>",
          B: "A <mark>discount</mark> on a bulk <mark>order</mark>",
          C: "A change in manufacturing <mark>costs</mark>",
          D: "A <mark>return policy</mark> for defective items",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A supplier's response about a shipment

대본 키워드: "Have you received a response from our supplier about the next shipment of steel components?"
보기 키워드: "A supplier's response about a shipment"

❌ 오답 트랩:
(B) A discount on a bulk order 
→ 할인 관련 내용 없음

(C) A change in manufacturing costs 
→ 제조 비용 변경 관련 언급 없음

(D) A return policy for defective items 
→ 반품 정책 관련 언급 없음`,
      },
      {
        id: 2,
        question: "How does <mark>the man</mark> react to the delay?",
        options: {
          A: "He asks if the order can be <mark>delivered</mark> <mark>earlier</mark>",
          B: "He <mark>cancels</mark> the order entirely",
          C: "He <mark>reschedules</mark> production for <mark>next</mark> month",
          D: "He <mark>increases</mark> the order <mark>quantity</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) He asks if the order can be delivered earlier

대본 키워드: "Can they expedite the delivery?"
보기 키워드: "He asks if the order can be delivered earlier"

❌ 오답 트랩:
(B) He cancels the order entirely 
→ 주문 취소 언급 없음

(C) He reschedules production for next month 
→ 생산 일정 변경 언급 없음

(D) He increases the order quantity 
→ 주문량 증가 언급 없음`,
      },
      {
        id: 3,
        question: "What alternative solution does the supplier offer?",
        options: {
          A: "Sending a <mark>partial shipment</mark> earlier",
          B: "Using a <mark>different</mark> shipping <mark>company</mark>",
          C: "Providing a <mark>refund</mark> for the <mark>delay</mark>",
          D: "Offering a <mark>free shipping</mark> upgrade",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Sending a partial shipment earlier

대본 키워드: "However, they can send a partial shipment tomorrow."
보기 키워드: "Sending a partial shipment earlier"

❌ 오답 트랩:
(B) Using a different shipping company 
→ 다른 배송 회사 이용 언급 없음

(C) Providing a refund for the delay 
→ 지연에 대한 환불 언급 없음

(D) Offering a free shipping upgrade 
→ 무료 배송 업그레이드 제안 언급 없음`,
      },
    ],
  },
  conversation7: {
    id: 7,
    title: "Placing an Urgent Order",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p7.mp3",
        script: `W: Hi, Kevin. We're almost out of <mark>packing materials</mark>. The last shipment was used up faster than expected.
<span class="translation">(안녕하세요, Kevin. 포장재가 거의 다 떨어졌어요. 마지막 배송분이 예상보다 빨리 소진됐네요.)</span>

M: That's a problem. How much stock do we have left?
<span class="translation">(문제네요. 재고가 얼마나 남았나요?)</span>

W: Only about ten rolls of packing tape and a few boxes of bubble wrap. <mark>We usually go through that amount in two days</mark>.
<span class="translation">(포장 테이프 10롤과 버블랩 몇 상자 정도만 남았어요. 보통 그 정도는 이틀이면 다 써요.)</span>

M: <mark>Then we'd better place an urgent order</mark>. Can our supplier deliver by tomorrow?
<span class="translation">(그럼 긴급 주문을 해야겠네요. 공급업체에서 내일까지 배송이 가능할까요?)</span>

W: <mark>I'll check with them now</mark>. If they can't, we might need to source from a different vendor.
<span class="translation">(지금 확인해보겠습니다. 안 된다면 다른 업체를 알아봐야 할 수도 있겠네요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What product is running low?",
        options: {
          A: "Printer <mark>paper</mark>",
          B: "<mark>Packing</mark> <mark>materials</mark>",
          C: "Ink <mark>cartridges</mark>",
          D: "Office <mark>chairs</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Packing materials

대본 키워드: "We're almost out of packing materials."
보기 키워드: "Packing materials"

❌ 오답 트랩:
(A) Printer paper 
→ 포장재 문제이지 프린터 용지가 아님

(C) Ink cartridges 
→ 잉크 카트리지 언급 없음

(D) Office chairs 
→ 사무용 의자 관련 언급 없음`,
      },
      {
        id: 2,
        question: "What concern does <mark>the woman</mark> raise?",
        options: {
          A: "The <mark>storage room</mark> is disorganized",
          B: "The current supply will only last <mark>two days</mark>",
          C: "The supplier has <mark>increased</mark> <mark>prices</mark>",
          D: "The <mark>delivery schedule</mark> is unclear",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The current supply will only last two days

대본 키워드: "We usually go through that amount in two days."
보기 키워드: "The current supply will only last two days"

❌ 오답 트랩:
(A) The storage room is disorganized 
→ 창고 정리 상태 언급 없음

(C) The supplier has increased prices 
→ 가격 인상 언급 없음

(D) The delivery schedule is unclear 
→ 배송 일정 불명확성 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the woman</mark> say she will do next?",
        options: {
          A: "Contact the supplier for an <mark>urgent</mark> <mark>order</mark>",
          B: "<mark>Move inventory</mark> to a different storage area",
          C: "Ask the <mark>finance team</mark> for budget approval",
          D: "Schedule a staff <mark>meeting</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Contact the supplier for an urgent order

대본 키워드: "I'll check with them now."
보기 키워드: "Contact the supplier for an urgent order"

❌ 오답 트랩:
(B) Move inventory to a different storage area 
→ 재고 이동 언급 없음

(C) Ask the finance team for budget approval 
→ 예산 승인 요청 언급 없음

(D) Schedule a staff meeting 
→ 직원 회의 일정 언급 없음`,
      },
    ],
  },
  conversation8: {
    id: 8,
    title: "Changing Delivery Time",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p8.mp3",
        script: `<mark>M</mark>: Hi, Rachel. I just spoke with our client, and they need their shipment to arrive a day <mark>earlier</mark> than planned.
<span class="translation">(안녕하세요, Rachel. 방금 고객과 통화했는데, 배송이 예정보다 하루 일찍 도착해야 한대요.)</span>

<mark>W</mark>: That might be difficult. The truck is already scheduled for <mark>Thursday</mark> afternoon.
<span class="translation">(어려울 수 있겠네요. 트럭이 이미 목요일 오후로 예약되어 있어요.)</span>

<mark>M</mark>: I understand, but they need it by Wednesday morning for their store opening.
<span class="translation">(알겠습니다만, 매장 오픈을 위해 수요일 아침까지는 필요하대요.)</span>

<mark>W</mark>: Let me check with the <mark>logistics team</mark>. If we load the shipment tonight, we might be able to send it out early tomorrow morning.
<span class="translation">(물류팀에 확인해보겠습니다. 오늘 밤에 선적하면 내일 아침 일찍 발송할 수 있을 것 같아요.)</span>

<mark>M</mark>: That would be great. Let me know what they say.
<span class="translation">(좋겠네요. 그들이 뭐라고 하는지 알려주세요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question:
          "What is the problem <mark>the speakers</mark> are discussing?",
        options: {
          A: "A shipment needs to arrive <mark>earlier</mark> than scheduled",
          B: "A customer received the <mark>wrong</mark> order",
          C: "A supplier is <mark>unable to meet</mark> demand",
          D: "A shipment was <mark>damaged</mark> during transit",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A shipment needs to arrive earlier than scheduled

대본 키워드: "They need their shipment to arrive a day earlier than planned."
보기 키워드: "A shipment needs to arrive earlier than scheduled"

❌ 오답 트랩:
(B) A customer received the wrong order 
→ 주문 오류가 아니라 배송 일정 변경 문제

(C) A supplier is unable to meet demand 
→ 공급업체 이슈 언급 없음

(D) A shipment was damaged during transit 
→ 배송 중 손상 언급 없음`,
      },
      {
        id: 2,
        question: "When was the shipment originally scheduled to arrive?",
        options: {
          A: "<mark>Tuesday</mark>",
          B: "<mark>Wednesday</mark>",
          C: "<mark>Thursday</mark>",
          D: "<mark>Friday</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Thursday

대본 키워드: "The truck is already scheduled for Thursday afternoon."
보기 키워드: "Thursday"

❌ 오답 트랩:
(A) Tuesday 
→ 화요일 언급 없음

(B) Wednesday 
→ 수요일은 변경 요청된 날짜

(D) Friday 
→ 금요일 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Check with the <mark>logistics</mark> <mark>team</mark>",
          B: "Call the <mark>client</mark> to request more time",
          C: "<mark>Order</mark> additional <mark>inventory</mark>",
          D: "<mark>Contact</mark> a different <mark>supplier</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Check with the logistics team

대본 키워드: "Let me check with the logistics team."
보기 키워드: "Check with the logistics team"

❌ 오답 트랩:
(B) Call the client to request more time 
→ 추가 시간 요청 언급 없음

(C) Order additional inventory 
→ 추가 재고 주문 언급 없음

(D) Contact a different supplier 
→ 다른 공급업체 연락 언급 없음`,
      },
    ],
  },
  conversation9: {
    id: 9,
    title: "Incorrect Product Delivery",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p9.mp3",
        script: `<mark>M</mark>: Hi, this is Michael from Weston Electronics. I just received my order, but there's a problem. I ordered 20 wireless keyboards, but instead, I received 20 <mark>wired models</mark>.
<span class="translation">(안녕하세요, Weston Electronics의 Michael입니다. 방금 주문한 물건을 받았는데 문제가 있네요. 무선 키보드 20개를 주문했는데, 유선 모델 20개를 받았어요.)</span>

<mark>W</mark>: I'm sorry about that. Could you confirm the order number so I can check what happened?
<span class="translation">(죄송합니다. 주문 번호를 확인해 주시면 무슨 일이 있었는지 확인해보겠습니다.)</span>

<mark>M</mark>: Sure, it's #57439.
<span class="translation">(네, #57439입니다.)</span>

<mark>W</mark>: Thank you. It looks like there was a <mark>packing error</mark> at our warehouse. We'll arrange for a replacement to be sent immediately.
<span class="translation">(감사합니다. 우리 창고에서 포장 오류가 있었던 것 같네요. 즉시 교체품을 보내드리도록 하겠습니다.)</span>

<mark>M</mark>: That would be great. Should I <mark>return the incorrect items</mark>?
<span class="translation">(좋습니다. 잘못 배송된 물품을 반품해야 하나요?)</span>

<mark>W</mark>: No need. You can keep them or donate them if you prefer.
<span class="translation">(필요 없습니다. 보관하시거나 원하시면 기부하셔도 됩니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What issue does <mark>the man</mark> report?",
        options: {
          A: "His order was <mark>delayed</mark>",
          B: "He received the <mark>wrong</mark> <mark>items</mark>",
          C: "His package was <mark>damaged</mark>",
          D: "He was <mark>charged</mark> <mark>incorrectly</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) He received the wrong items

대본 키워드: "I ordered 20 wireless keyboards, but instead, I received 20 wired models."
보기 키워드: "He received the wrong items"

❌ 오답 트랩:
(A) His order was delayed 
→ 배송 지연이 아니라 제품 오류

(C) His package was damaged 
→ 손상 관련 언급 없음

(D) He was charged incorrectly 
→ 결제 오류가 아니라 잘못된 제품 배송`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> say about the mistake?",
        options: {
          A: "It was due to a <mark>warehouse</mark> <mark>error</mark>",
          B: "The customer entered the <mark>wrong</mark> <mark>information</mark>",
          C: "The product is no longer in <mark>stock</mark>",
          D: "The delivery company <mark>lost</mark> the <mark>package</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) It was due to a warehouse error

대본 키워드: "It looks like there was a packing error at our warehouse."
보기 키워드: "It was due to a warehouse error"

❌ 오답 트랩:
(B) The customer entered the wrong information 
→ 고객의 정보 입력 오류 언급 없음

(C) The product is no longer in stock 
→ 재고 부족 언급 없음

(D) The delivery company lost the package 
→ 배송사의 분실 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the man</mark> ask about?",
        options: {
          A: "Whether he should <mark>return</mark> the <mark>incorrect</mark> <mark>items</mark>",
          B: "If he can receive a <mark>discount</mark> on his next order",
          C: "Whether he can <mark>exchange</mark> the product in-store",
          D: "If he will receive a full <mark>refund</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Whether he should return the incorrect items

대본 키워드: "Should I return the incorrect items?"
보기 키워드: "Whether he should return the incorrect items"

❌ 오답 트랩:
(B) If he can receive a discount on his next order 
→ 할인 요청 언급 없음

(C) Whether he can exchange the product in-store 
→ 매장 내 교환 언급 없음

(D) If he will receive a full refund 
→ 환불 관련 언급 없음`,
      },
    ],
  },

  conversation10: {
    id: 10,
    title: "Customs Issues",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p10.mp3",
        script: `<mark>W</mark>: Hi, Daniel. I just received an update from our shipping provider. One of our international shipments is being <mark>held at customs</mark>.
<span class="translation">(안녕하세요, Daniel. 방금 배송업체로부터 업데이트를 받았어요. 우리의 국제 화물 중 하나가 세관에 묶여있대요.)</span>

<mark>M</mark>: That's not good. Do we know the reason for the delay?
<span class="translation">(좋지 않네요. 지연 이유를 알고 있나요?)</span>

<mark>W</mark>: Yes, they said the <mark>commercial invoice</mark> was missing some required details. The customs office needs a revised document before they can process it.
<span class="translation">(네, 상업송장에 필수 정보가 일부 누락됐대요. 세관에서 처리하기 전에 수정된 서류가 필요하다고 해요.)</span>

<mark>M</mark>: That's an easy fix. Can we send them the updated invoice today?
<span class="translation">(쉽게 해결할 수 있겠네요. 오늘 수정된 송장을 보낼 수 있나요?)</span>

<mark>W</mark>: I've already contacted our <mark>logistics team</mark>. They're preparing the <mark>document</mark> now and will send it <mark>within the hour</mark>.
<span class="translation">(이미 물류팀에 연락했어요. 지금 서류를 준비 중이고 한 시간 안에 보낼 거예요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem are <mark>the speakers</mark> discussing?",
        options: {
          A: "A shipment was sent to the <mark>wrong</mark> <mark>address</mark>",
          B: "A package is being held at <mark>customs</mark>",
          C: "A customer <mark>canceled</mark> an <mark>order</mark>",
          D: "A <mark>delivery truck</mark> broke down",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A package is being held at customs

대본 키워드: "One of our international shipments is being held at customs."
보기 키워드: "A package is being held at customs"

❌ 오답 트랩:
(A) A shipment was sent to the wrong address 
→ 주소 오류가 아니라 서류 문제

(C) A customer canceled an order 
→ 고객 주문 취소 언급 없음

(D) A delivery truck broke down 
→ 운송 수단 문제 언급 없음`,
      },
      {
        id: 2,
        question: "What caused the delay?",
        options: {
          A: "The <mark>customs office</mark> is understaffed",
          B: "The shipment contained <mark>restricted</mark> <mark>items</mark>",
          C: "The <mark>commercial invoice</mark> was incomplete",
          D: "The company failed to pay the <mark>shipping</mark> fee",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The commercial invoice was incomplete

대본 키워드: "The commercial invoice was missing some required details."
보기 키워드: "The commercial invoice was incomplete"

❌ 오답 트랩:
(A) The customs office is understaffed 
→ 세관 인력 부족 언급 없음
(B) The shipment contained restricted items 
→ 제한 품목 포함 언급 없음

(D) The company failed to pay the shipping fee 
→ 배송비 미지급 언급 없음`,
      },
      {
        id: 3,
        question: "What will happen next?",
        options: {
          A: "The <mark>logistics team</mark> will <mark>send</mark> the updated invoice",
          B: "The woman will <mark>contact the client</mark> for confirmation",
          C: "The <mark>customs</mark> office will <mark>reject</mark> the shipment",
          D: "The company will change the <mark>delivery address</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) The logistics team will send the updated invoice

대본 키워드: "They're preparing the document now and will send it within the hour."
보기 키워드: "The logistics team will send the updated invoice"

❌ 오답 트랩:
(B) The woman will contact the client for confirmation 
→ 클라이언트와 연락하는 내용 없음

(C) The customs office will reject the shipment 
→ 세관이 거부할 것이라는 내용 없음, 서류 제출 후 해결될 가능성이 높음

(D) The company will change the delivery address 
→ 배송지 변경 관련 언급 없음`,
      },
    ],
  },
  conversation11: {
    id: 11,
    title: "International Logistics",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p11.mp3",
        script: `<mark>M</mark>: Hi, Sarah. I just checked the tracking system, and our shipment to Germany is <mark>behind schedule</mark>.
<span class="translation">(안녕하세요, Sarah. 방금 추적 시스템을 확인했는데, 독일행 화물이 일정보다 늦어지고 있어요.)</span>

<mark>W</mark>: Really? Do we know why it's delayed?
<span class="translation">(정말요? 지연 이유를 알고 있나요?)</span>

<mark>M</mark>: The freight company reported that <mark>bad weather</mark> caused flight disruptions, so our cargo didn't depart on time.
<span class="translation">(화물 회사에서 악천후로 인해 항공편이 차질을 빚어서 화물이 제시간에 출발하지 못했다고 보고했어요.)</span>

<mark>W</mark>: That's unfortunate. Do we have an alternative route available?
<span class="translation">(안타깝네요. 대체 경로가 있나요?)</span>

<mark>M</mark>: I checked, and they can send it by <mark>ocean freight</mark>, but it will take three extra days.
<span class="translation">(확인해보니 해상 운송으로 보낼 수 있지만, 3일이 더 걸릴 거예요.)</span>

<mark>W</mark>: We may not have another option. Let's inform the client and confirm if they're okay with the delay.
<span class="translation">(다른 선택지가 없을 것 같네요. 고객에게 알리고 지연을 수락할 수 있는지 확인해보죠.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem do <mark>the speakers</mark> mention?",
        options: {
          A: "A shipment has been <mark>delayed</mark>",
          B: "A supplier sent <mark>defective</mark> <mark>goods</mark>",
          C: "<mark>Customs</mark> <mark>fees</mark> have increased",
          D: "A <mark>warehouse</mark> is running out of <mark>space</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A shipment has been delayed

대본 키워드: "Our shipment to Germany is behind schedule."
보기 키워드: "A shipment has been delayed"

❌ 오답 트랩:
(B) A supplier sent defective goods 
→ 불량품 관련 언급 없음

(C) Customs fees have increased 
→ 관세 인상 언급 없음

(D) A warehouse is running out of space 
→ 창고 공간 부족 언급 없음`,
      },
      {
        id: 2,
        question: "What caused the problem?",
        options: {
          A: "A <mark>labeling mistake</mark> on the shipment",
          B: "<mark>Bad weather</mark> affecting flights",
          C: "A <mark>miscommunication</mark> with the supplier",
          D: "A shortage of <mark>shipping containers</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Bad weather affecting flights

대본 키워드: "The freight company reported that bad weather caused flight disruptions, so our cargo didn't depart on time."
보기 키워드: "Bad weather affecting flights"

❌ 오답 트랩:
(A) A labeling mistake on the shipment 
→ 라벨링 오류 언급 없음

(C) A miscommunication with the supplier 
→ 공급업체와의 소통 문제 언급 없음

(D) A shortage of shipping containers 
→ 컨테이너 부족 언급 없음`,
      },
      {
        id: 3,
        question: "What alternative shipping method is suggested?",
        options: {
          A: "<mark>Air</mark> freight",
          B: "<mark>Train</mark> transportation",
          C: "<mark>Ocean</mark> freight",
          D: "<mark>Courier</mark> <mark>service</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Ocean freight

대본 키워드: "They can send it by ocean freight, but it will take three extra days."
보기 키워드: "Ocean freight"

❌ 오답 트랩:
(A) Air freight 
→ 항공 운송은 현재 지연된 방식

(B) Train transportation 
→ 철도 운송 언급 없음

(D) Courier service 
→ 택배 서비스 언급 없음`,
      },
    ],
  },
  conversation12: {
    id: 12,
    title: "Traffic Conditions",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p12.mp3",
        script: `<mark>M</mark>: Hi, Rachel. I just checked the GPS, and there's <mark>heavy traffic</mark> on the main highway. The delivery trucks might not reach the distribution center on time.
<span class="translation">(안녕하세요, Rachel. 방금 GPS를 확인했는데, 주요 고속도로에 심한 정체가 있어요. 배송 트럭들이 물류센터에 제시간에 도착하지 못할 것 같아요.)</span>

<mark>W</mark>: That's not good. Is there an alternative route available?
<span class="translation">(좋지 않네요. 대체 경로가 있나요?)</span>

<mark>M</mark>: There's a <mark>side road</mark> that avoids the congestion, but it will add 30 minutes to the trip.
<span class="translation">(정체를 피할 수 있는 우회도로가 있지만, 30분이 더 걸릴 거예요.)</span>

<mark>W</mark>: That's still better than sitting in traffic for hours. Let's reroute the trucks and <mark>inform the distribution center</mark> about the delay.
<span class="translation">(그래도 몇 시간씩 정체에 갇혀있는 것보다는 낫네요. 트럭들의 경로를 변경하고 물류센터에 지연 사실을 알리죠.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What issue are <mark>the speakers</mark> discussing?",
        options: {
          A: "A delay due to <mark>heavy</mark> <mark>traffic</mark>",
          B: "A shipment that was <mark>lost</mark>",
          C: "A supplier is <mark>unable to meet</mark> demand",
          D: "A warehouse is running out of <mark>space</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A delay due to heavy traffic

대본 키워드: "There's heavy traffic on the main highway."
보기 키워드: "A delay due to heavy traffic"

❌ 오답 트랩:
(B) A shipment that was lost 
→ 분실 언급 없음

(C) A supplier is unable to meet demand 
→ 공급업체 이슈 언급 없음

(D) A warehouse is running out of space 
→ 창고 공간 부족 언급 없음`,
      },
      {
        id: 2,
        question: "What alternative route does <mark>the man</mark> mention?",
        options: {
          A: "Using a <mark>different</mark> highway",
          B: "Taking a <mark>side</mark> <mark>road</mark>",
          C: "A <mark>shortcut</mark> through the city",
          D: "A <mark>toll</mark> <mark>road</mark> bypass",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Taking a side road
      
      대본 키워드: "There's a side road that avoids the congestion, but it will add 30 minutes to the trip."
      보기 키워드: "Taking a side road"
      
      ❌ 오답 트랩:
      (A) Using a different highway 
      → 다른 고속도로 언급 없음
      
      (C) A shortcut through the city 
      → 도시 경유 지름길 언급 없음
      
      (D) A toll road bypass 
      → 유료도로 우회로 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the speakers</mark> most likely do next?",
        options: {
          A: "<mark>Notify</mark> the <mark>distribution center</mark> about the <mark>delay</mark>",
          B: "Request a <mark>refund</mark> for late <mark>delivery</mark>",
          C: "<mark>Cancel</mark> the <mark>shipment</mark>",
          D: "Ask the <mark>drivers</mark> to return to the warehouse",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Notify the distribution center about the delay

대본 키워드: "Let's reroute the trucks and inform the distribution center about the delay."
보기 키워드: "Notify the distribution center about the delay"

❌ 오답 트랩:
(B) Request a refund for late delivery 
→ 환불 요청 언급 없음

(C) Cancel the shipment 
→ 배송 취소 언급 없음

(D) Ask the drivers to return to the warehouse 
→ 창고 복귀 언급 없음`,
      },
    ],
  },

  conversation13: {
    id: 13,
    title: "Printer Cartridge Inventory",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p13.mp3",
        script: `<mark>M</mark>: Hi, Sarah. I just checked the inventory, and we're <mark>almost out of printer cartridges</mark>. There are only two left in stock.
<span class="translation">(안녕하세요, Sarah. 방금 재고를 확인했는데, 프린터 카트리지가 거의 다 떨어졌어요. 재고가 2개밖에 안 남았어요.)</span>

<mark>W</mark>: Oh, really? That's not good. I thought we had ordered more last month. Did you check if the supplier has shipped our latest order?
<span class="translation">(오, 정말요? 좋지 않네요. 지난달에 더 주문했다고 생각했는데. 공급업체가 최근 주문한 것을 발송했는지 확인해보셨나요?)</span>

<mark>M</mark>: Yes, I just called them. <mark>The shipment was delayed, but they said it should arrive by Friday</mark>.
<span class="translation">(네, 방금 전화했어요. 배송이 지연됐지만, 금요일까지는 도착할 거래요.)</span>

<mark>W</mark>: Alright. Just to be safe, <mark>let's place an additional order</mark>. We use printer cartridges every day, so we don't want to run out completely.
<span class="translation">(알겠어요. 안전하게 추가 주문을 넣죠. 프린터 카트리지를 매일 사용하니까 완전히 떨어지면 안 되겠어요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the conversation?",
        options: {
          A: "An office <mark>relocation</mark>",
          B: "A <mark>low</mark> <mark>inventory</mark> issue",
          C: "A product <mark>demonstration</mark>",
          D: "A <mark>company</mark> <mark>budget</mark> <mark>review</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A low inventory issue

대본 키워드: "We're almost out of printer cartridges."
보기 키워드: "A low inventory issue"

❌ 오답 트랩:
(A) An office relocation 
→ 사무실 이전 언급 없음

(C) A product demonstration 
→ 제품 시연 언급 없음

(D) A company budget review 
→ 예산 검토 언급 없음`,
      },
      {
        id: 2,
        question: "When is the shipment expected to arrive?",
        options: {
          A: "Later <mark>today</mark>",
          B: "By <mark>Friday</mark>",
          C: "Next <mark>Monday</mark>",
          D: "In <mark>two</mark> <mark>weeks</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) By Friday
      
      대본 키워드: "The shipment was delayed, but they said it should arrive by Friday."
      보기 키워드: "By Friday"
      
      ❌ 오답 트랩:
      (A) Later today 
      → 오늘 도착 언급 없음
      
      (C) Next Monday 
      → 월요일 도착 언급 없음
      
      (D) In two weeks 
      → 2주 후 도착 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the woman</mark> decide to do?",
        options: {
          A: "Place an <mark>additional</mark> order",
          B: "<mark>Call</mark> the <mark>supplier</mark> again",
          C: "Use <mark>fewer</mark> printer cartridges",
          D: "Check <mark>other</mark> <mark>suppliers</mark> for alternatives",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Place an additional order

대본 키워드: "Just to be safe, let's place an additional order."
보기 키워드: "Place an additional order"

❌ 오답 트랩:
(B) Call the supplier again 
→ 공급업체에 재연락하는 것이 아님

(C) Use fewer printer cartridges 
→ 사용량 감소 언급 없음

(D) Check other suppliers for alternatives 
→ 다른 공급업체 확인 언급 없음`,
      },
    ],
  },
  conversation14: {
    id: 14,
    title: "Product Return Request",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/p1/p14.mp3",
        script: `<mark>M</mark>: Hi, I just received a call from a <mark>customer who wants to return a defective blender</mark>. She said it stopped working after only two weeks of use.
<span class="translation">(안녕하세요, 방금 고객으로부터 전화를 받았는데요, 불량인 블렌더를 반품하고 싶다고 하네요. 사용한 지 2주 만에 작동이 멈췄대요.)</span>

<mark>W</mark>: Oh, that's unfortunate. <mark>Do you know if she has the receipt?</mark> Our return policy requires proof of purchase.
<span class="translation">(오, 안타깝네요. 영수증은 가지고 있나요? 반품 정책상 구매 증빙이 필요해요.)</span>

<mark>M</mark>: Yes, she mentioned that she still has the receipt and the original packaging. <mark>She also asked if she could exchange it for a new one</mark> instead of getting a refund.
<span class="translation">(네, 영수증과 원래 포장도 가지고 있다고 하네요. 환불 대신 새 제품으로 교환할 수 있는지도 문의했어요.)</span>

<mark>W</mark>: That should be fine. <mark>Just let her know that she can bring it to any of our stores, and we will process the exchange for her</mark>.
<span class="translation">(괜찮을 것 같네요. 아무 매장에나 가져오시면 교환해드릴 수 있다고 알려주세요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the conversation?",
        options: {
          A: "A <mark>delayed product</mark> shipment",
          B: "A <mark>store closing</mark> announcement",
          C: "A customer <mark>return request</mark>",
          D: "A <mark>new product</mark> launch",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) A customer return request

대본 키워드: "A customer who wants to return a defective blender."
보기 키워드: "A customer return request"

❌ 오답 트랩:
(A) A delayed product shipment 
→ 배송 지연이 아닌 제품 반품 문제

(B) A store closing announcement 
→ 매장 폐쇄 언급 없음

(D) A new product launch 
→ 신제품 출시 언급 없음`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> ask about?",
        options: {
          A: "Whether the customer received a <mark>discount</mark>",
          B: "Whether the customer has the <mark>receipt</mark>",
          C: "Whether the customer contacted <mark>customer service</mark>",
          D: "Whether the customer has <mark>used</mark> the product <mark>before</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Whether the customer has the receipt

대본 키워드: "Do you know if she has the receipt?"
보기 키워드: "Whether the customer has the receipt"

❌ 오답 트랩:
(A) Whether the customer received a discount 
→ 할인 관련 문의 없음

(C) Whether the customer contacted customer service 
→ 고객 서비스 접촉 여부 문의 없음

(D) Whether the customer has used the product before 
→ 제품 사용 여부 문의 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "<mark>Inform</mark> the <mark>customer</mark> about the return process",
          B: "Send a refund request to the <mark>finance department</mark>",
          C: "Contact <mark>the supplier</mark> for a replacement",
          D: "Offer the customer <mark>a discount</mark> on future purchases",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Inform the customer about the return process

대본 키워드: "Just let her know that she can bring it to any of our stores, and we will process the exchange."
보기 키워드: "Inform the customer about the return process"

❌ 오답 트랩:
(B) Send a refund request to the finance department 
→ 환불이 아닌 교환 처리 예정

(C) Contact the supplier for a replacement 
→ 공급업체 연락 언급 없음

(D) Offer the customer a discount on future purchases 
→ 향후 구매 할인 제안 언급 없음`,
      },
    ],
  },
};
